import { createSlice } from '@reduxjs/toolkit';

const welcomeEmailSlice = createSlice({
  name: 'welcomeEmail',
  initialState: {
    loading: false,
    successMessage: '',
    errorMessage: '',
  },
  reducers: {
    sendWelcomeEmail: (state) => {
        console.log('state')
      state.loading = true;
      state.successMessage = '';
      state.errorMessage = '';
    },
    sendWelcomeEmailSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload;
      state.errorMessage = '';
    },
    sendWelcomeEmailFailure: (state, action) => {
      state.loading = false;
      state.successMessage = '';
      state.errorMessage = action.payload;
    },
  },
});

export const { sendWelcomeEmail, sendWelcomeEmailSuccess, sendWelcomeEmailFailure } = welcomeEmailSlice.actions;
export default welcomeEmailSlice.reducer;
